"use client";

import { useMonarchRule } from "../MonarchRulesProvider";
import type {
  SuperlativesModuleData,
  SuperlativesModuleTestResult,
  UseSuperlativesModule,
} from "./types";

export const SUPERLATIVES_MODULE_RULE_ID = "superlativesModule";

const useSuperlativesModule: UseSuperlativesModule = () => {
  const { isLoading, value } = useMonarchRule<{
    data: SuperlativesModuleData;
  }>(SUPERLATIVES_MODULE_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
      data: {
        isEnabled: false,
      },
    } as SuperlativesModuleTestResult;
  }

  const data: SuperlativesModuleData = value?.data ?? { isEnabled: false };
  const variant = data?.isEnabled ? "test" : "control";

  return {
    isLoading: false,
    variant,
    data: {
      isEnabled: data.isEnabled,
      title: data.title,
      mobileDisplayLimit: data.mobileDisplayLimit ?? 2,
      numberOfProducts: data.numberOfProducts ?? 3,
      searchLocation: data.searchLocation,
      displayOnAuthX: data.displayOnAuthX,
      collections: data.collections,
    },
  };
};

export default useSuperlativesModule;
